import Cookies from 'js-cookie'

const TokenKey = `Authorization_App_${process.env.VUE_APP_ENV}`

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
